
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/moments",
      function () {
        return require("private-next-pages/marketplace/moments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/moments"])
      });
    }
  